import React from 'react';
import FinanceTooltipPanel from '../../../financeShared/FinanceTooltipPanel';

const TooltipTipos = ({ active, payload, label, tiposComContas }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    const totalContas = Number(data.totalContas) || tiposComContas.reduce((sum, tipo) => sum + (Number(data[tipo.dataKey]) || 0), 0);
    const rows = tiposComContas
      .map((tipoConfig) => {
        const valor = Number(data[tipoConfig.dataKey]) || 0;
        if (valor <= 0) return null;
        const percentual = totalContas > 0 ? (valor / totalContas) * 100 : 0;
        return {
          id: tipoConfig.dataKey,
          label: tipoConfig.nome,
          dotColor: tipoConfig.cor,
          value: `${valor} (${percentual.toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%)`,
        };
      })
      .filter(Boolean);
    
    return (
      <FinanceTooltipPanel
        title={data.nomeCompleto || label}
        rows={rows}
        totalText={`Total: ${totalContas} conta${totalContas !== 1 ? 's' : ''} nesta conta bancária`}
        emptyText="Sem tipos de pagamento registrados."
      />
    );
  }
  return null;
};

export default TooltipTipos;



